/**
 * Chuẩn hoá field `possibly_incomplete_orders` từ API GET /packing/boxes/:boxId/items.
 *
 * Payload mỗi phần tử:
 *   barcode_number  - số barcode của đơn
 *   item_count      - tổng số sản phẩm của đơn
 *   item_in_box     - số sản phẩm của đơn đang nằm trong thùng đang xem
 *   unpacked_items  - số sản phẩm của đơn chưa được tích vào thùng nào
 *
 * Phần còn lại (item_count - item_in_box - unpacked_items) là sản phẩm đã tích ở thùng khác.
 */
const parseIncompleteOrders = (list) => {
    const vList = Array.isArray(list) ? list : []

    return vList
        .map(order => {
            const {barcode_number, item_count, item_in_box, unpacked_items} = Object.assign({}, order)

            // API trả barcode_number là number còn item.item_number là string
            // → quy về string để về sau so sánh được với box item
            const barcodeNumber = String(barcode_number || '').trim()
            const itemCount = parseInt(item_count, 10) || 0
            const itemInBox = parseInt(item_in_box, 10) || 0
            const unpacked = parseInt(unpacked_items, 10) || 0

            if (!barcodeNumber || unpacked <= 0) return false

            return {
                barcodeNumber,
                itemCount,
                itemInBox,
                unpacked,
                // Số SP đã được tích vào thùng nào đó (gồm cả thùng này) — dùng cho thanh tiến độ.
                // Math.max để chặn số âm: không đảm bảo item_count >= unpacked_items
                packed: Math.max(itemCount - unpacked, 0),
            }
        })
        .filter(Boolean)
        // thiếu nhiều nhất lên đầu để nhân viên xử lý đơn nghiêm trọng trước
        .sort((a, b) => b.unpacked - a.unpacked || (a.barcodeNumber > b.barcodeNumber ? 1 : -1))
}

export default parseIncompleteOrders
